/* INN8 Foods — redesign behaviour (tabs, header menu, cart, product form, gallery, diagram pins, dialogs, mix split). */
(function () {
  'use strict';

  var root = (window.routes && window.routes.root_url) || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (root.charAt(root.length - 1) !== '/') root += '/';
  var CART_URL = (window.routes && window.routes.cart_url) || root + 'cart';

  /* ---------------------------------------------------------------- cart */
  function setCartCount(n) {
    document.querySelectorAll('[data-inn8-cart-count]').forEach(function (el) { el.textContent = n; });
  }
  function refreshCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCartCount(cart.item_count); return cart; })
      .catch(function () {});
  }
  function addToCart(items) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (body) {
        if (!r.ok || body.status) throw new Error(body.description || body.message || 'Could not add to cart');
        document.dispatchEvent(new CustomEvent('inn8:cart-updated'));
        refreshCart();
        return body;
      });
    });
  }
  window.INN8 = { addToCart: addToCart, refreshCart: refreshCart };

  /* --------------------------------------------------------- smooth scroll */
  var anim = null;
  var lockUntil = 0;
  function tabsHeight() {
    var bar = document.querySelector('[data-inn8-tabs]');
    return bar ? bar.getBoundingClientRect().height : 0;
  }
  function syncTabsHeight() {
    document.documentElement.style.setProperty('--inn8-tabs-h', tabsHeight() + 'px');
  }
  function smoothTo(el) {
    var sc = document.scrollingElement || document.documentElement;
    var from = sc.scrollTop;
    var to = Math.max(0, Math.min(sc.scrollHeight - sc.clientHeight, from + Math.round(el.getBoundingClientRect().top - tabsHeight())));
    if (anim) cancelAnimationFrame(anim);
    var dist = Math.abs(to - from);
    if (dist < 2) return;
    var dur = Math.min(1100, Math.max(450, dist * 0.35));
    var start = performance.now();
    var ease = function (t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };
    var prev = sc.style.scrollBehavior;
    sc.style.scrollBehavior = 'auto';
    lockUntil = start + dur + 120;
    var step = function (now) {
      var t = Math.min(1, (now - start) / dur);
      sc.scrollTop = from + (to - from) * ease(t);
      if (t < 1) anim = requestAnimationFrame(step);
      else { anim = null; sc.style.scrollBehavior = prev; }
    };
    anim = requestAnimationFrame(step);
  }

  // Land on a section after arriving from another page. Images above it keep loading
  // and push it down, so keep re-aligning until the page settles or the shopper scrolls.
  function landOn(el) {
    var sc = document.scrollingElement || document.documentElement;
    var stop = false;
    var cancel = function () { stop = true; };
    ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(function (ev) {
      window.addEventListener(ev, cancel, { once: true, passive: true });
    });
    var align = function () {
      if (stop || anim) return;
      var delta = Math.round(el.getBoundingClientRect().top - tabsHeight());
      if (Math.abs(delta) > 3) sc.scrollTop += delta;
    };
    setTimeout(function () { if (!stop) smoothTo(el); }, 60);
    var ticks = 0;
    var timer = setInterval(function () {
      align();
      if (stop || ++ticks > 30) clearInterval(timer);
    }, 150);
    window.addEventListener('load', function () { setTimeout(align, 50); }, { once: true });
  }

  /* ------------------------------------------------------------------ tabs */
  function initTabs(scope) {
    var bar = (scope || document).querySelector('[data-inn8-tabs]');
    if (!bar || bar.dataset.ready) return;
    bar.dataset.ready = '1';
    var tabs = Array.prototype.slice.call(bar.querySelectorAll('[data-inn8-tab]'));
    var setCurrent = function (id) {
      tabs.forEach(function (t) {
        var on = t.dataset.inn8Tab === id;
        t.setAttribute('aria-current', on ? 'true' : 'false');
        if (on && t.scrollIntoView && bar.querySelector('.inn8-tabs__row').scrollWidth > bar.clientWidth) {
          var row = bar.querySelector('.inn8-tabs__row');
          row.scrollTo({ left: t.offsetLeft - 24, behavior: 'smooth' });
        }
      });
    };
    tabs.forEach(function (t) {
      t.addEventListener('click', function (e) {
        var target = document.getElementById(t.dataset.inn8Tab);
        if (!target) return; // not on this page: follow the link to the homepage anchor
        e.preventDefault();
        setCurrent(t.dataset.inn8Tab);
        smoothTo(target);
        if (history.replaceState) history.replaceState(null, '', '#' + t.dataset.inn8Tab);
      });
    });
    var onPage = tabs.filter(function (t) { return document.getElementById(t.dataset.inn8Tab); });
    if (bar.dataset.current) setCurrent(bar.dataset.current);
    if (!onPage.length) return;
    var spy = function () {
      if (performance.now() < lockUntil) return;
      var line = bar.getBoundingClientRect().bottom + 2;
      var current = null;
      onPage.forEach(function (t) {
        var el = document.getElementById(t.dataset.inn8Tab);
        if (el.getBoundingClientRect().top <= line) current = t.dataset.inn8Tab;
      });
      setCurrent(current || '');
    };
    document.addEventListener('scroll', spy, { passive: true });
    spy();
    // Arriving from another page with a hash: glide to it once layout settles.
    if (location.hash) {
      var hashEl = document.getElementById(decodeURIComponent(location.hash.slice(1)));
      if (hashEl) landOn(hashEl);
    }
  }

  // Any other in-page link marked data-inn8-scroll also glides.
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="#"]');
    if (!a || !a.closest('.inn8') || a.hasAttribute('data-inn8-tab')) return;
    var url = new URL(a.href, location.href);
    if (url.pathname !== location.pathname || !url.hash) return;
    var el = document.getElementById(decodeURIComponent(url.hash.slice(1)));
    if (!el) return;
    e.preventDefault();
    smoothTo(el);
  });

  /* ---------------------------------------------------------------- header */
  function initHeader(scope) {
    (scope || document).querySelectorAll('[data-inn8-menu-toggle]').forEach(function (btn) {
      if (btn.dataset.ready) return;
      btn.dataset.ready = '1';
      var drawer = document.getElementById(btn.getAttribute('aria-controls'));
      if (!drawer) return;
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') !== 'true';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        drawer.classList.toggle('is-open', open);
      });
    });
  }

  /* ------------------------------------------------------------ quick add */
  function initQuickAdd(scope) {
    (scope || document).querySelectorAll('form[data-inn8-quick-add]').forEach(function (form) {
      if (form.dataset.ready) return;
      form.dataset.ready = '1';
      var btn = form.querySelector('[type="submit"]');
      var label = btn ? btn.textContent : '';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (form.dataset.added) { location.href = CART_URL; return; }
        var id = form.querySelector('[name="id"]').value;
        btn.setAttribute('aria-disabled', 'true');
        addToCart([{ id: Number(id), quantity: 1 }])
          .then(function () {
            form.dataset.added = '1';
            btn.textContent = btn.dataset.addedLabel || 'added ✓ — view cart';
          })
          .catch(function (err) { btn.textContent = err.message; setTimeout(function () { btn.textContent = label; }, 2600); })
          .then(function () { btn.removeAttribute('aria-disabled'); });
      });
    });
  }

  /* --------------------------------------------------------------- gallery */
  function initGallery(scope) {
    (scope || document).querySelectorAll('[data-inn8-gallery]').forEach(function (g) {
      if (g.dataset.ready) return;
      g.dataset.ready = '1';
      var wrap = g.querySelector('[data-gallery-main]');
      var main = wrap && wrap.querySelector('img');
      var thumbs = g.querySelectorAll('[data-thumb]');
      var show = function (btn) {
        if (!main || !btn) return;
        main.src = btn.dataset.src;
        main.removeAttribute('srcset');
        main.alt = btn.dataset.alt || '';
        thumbs.forEach(function (t) { t.setAttribute('aria-pressed', t === btn ? 'true' : 'false'); });
      };
      thumbs.forEach(function (t) { t.addEventListener('click', function () { show(t); }); });
      g.inn8Show = function (mediaId) {
        var hit = g.querySelector('[data-thumb][data-media-id="' + mediaId + '"]');
        if (hit) show(hit);
      };
    });
  }

  /* --------------------------------------------------------------- product */
  function initProduct(scope) {
    (scope || document).querySelectorAll('[data-inn8-product]').forEach(function (el) {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      var dataEl = el.querySelector('script[data-inn8-product-json]');
      if (!dataEl) return;
      var data = JSON.parse(dataEl.textContent);
      var byId = {};
      data.variants.forEach(function (v) { byId[v.id] = v; });

      var form = el.querySelector('form[data-inn8-form]');
      var idInput = el.querySelector('[data-id-input]');
      var planInput = el.querySelector('[data-plan-input]');
      var qtyWrap = el.querySelector('[data-qty]');
      var qtyInput = el.querySelector('[data-qty-input]');
      var addBtn = el.querySelector('[data-add]');
      var msg = el.querySelector('[data-msg]');
      var priceEl = el.querySelector('[data-price]');
      var compareEl = el.querySelector('[data-compare]');
      var noteEl = el.querySelector('[data-note]');
      var packsSet = el.querySelector('[data-packs]');
      var plansSet = el.querySelector('[data-plans]');
      var freqWrap = el.querySelector('[data-frequency-wrap]');
      var freqSel = el.querySelector('[data-frequency]');
      var gallery = document.querySelector('[data-inn8-gallery]');

      var state = {
        mode: el.dataset.mode || 'once',
        once: Number(el.dataset.onceVariant),
        sub: Number(el.dataset.subVariant),
        plan: el.dataset.plan ? Number(el.dataset.plan) : null,
        added: false
      };

      var current = function () { return byId[state.mode === 'sub' ? state.sub : state.once]; };

      // Mix & match split: two linked steppers that always add up to the bags in the pack.
      var splitEl = data.split ? el.querySelector('[data-split]') : null;
      var split = { a: 0, b: 0, bags: 0 };
      var splitRender = function () {
        if (!splitEl) return;
        splitEl.querySelector('[data-split-a]').textContent = split.a;
        splitEl.querySelector('[data-split-b]').textContent = split.b;
        splitEl.querySelector('[data-split-input-a]').value = split.a;
        splitEl.querySelector('[data-split-input-b]').value = split.b;
        splitEl.querySelectorAll('[data-split-step]').forEach(function (b) {
          var s = Number(b.dataset.splitStep);
          b.disabled = s < 0 ? split.a <= 0 : split.b <= 0;
        });
        splitEl.querySelectorAll('[data-split-step-b]').forEach(function (b) {
          var s = Number(b.dataset.splitStepB);
          b.disabled = s < 0 ? split.b <= 0 : split.a <= 0;
        });
      };
      var splitSync = function (v) {
        if (!splitEl || !v) return;
        var bags = v.bags || 1;
        if (bags !== split.bags) {
          split.bags = bags;
          split.a = Math.ceil(bags / 2);
          split.b = bags - split.a;
        }
        splitRender();
      };
      if (splitEl) {
        var move = function (toA) {
          if (toA && split.b > 0) { split.a++; split.b--; }
          if (!toA && split.a > 0) { split.a--; split.b++; }
          state.added = false; render();
        };
        splitEl.querySelectorAll('[data-split-step]').forEach(function (b) {
          b.addEventListener('click', function () { move(Number(b.dataset.splitStep) > 0); });
        });
        splitEl.querySelectorAll('[data-split-step-b]').forEach(function (b) {
          b.addEventListener('click', function () { move(Number(b.dataset.splitStepB) < 0); });
        });
      }
      var currentAlloc = function (v) {
        if (state.mode !== 'sub' || !v.allocations.length) return null;
        var hit = v.allocations.filter(function (a) { return a.plan_id === state.plan; })[0];
        return hit || v.allocations[0];
      };

      var render = function () {
        var v = current();
        if (!v) return;
        var alloc = currentAlloc(v);
        if (alloc) state.plan = alloc.plan_id;

        el.querySelectorAll('[data-mode-btn]').forEach(function (b) {
          b.setAttribute('aria-pressed', b.dataset.modeBtn === state.mode ? 'true' : 'false');
        });
        if (packsSet) packsSet.hidden = state.mode === 'sub';
        if (plansSet) plansSet.hidden = state.mode !== 'sub';
        el.querySelectorAll('[data-pack]').forEach(function (b) {
          b.setAttribute('aria-pressed', Number(b.dataset.pack) === state.once ? 'true' : 'false');
        });
        el.querySelectorAll('[data-plan-variant]').forEach(function (b) {
          b.setAttribute('aria-pressed', Number(b.dataset.planVariant) === state.sub ? 'true' : 'false');
        });
        if (qtyWrap) qtyWrap.hidden = state.mode === 'sub';
        if (state.mode === 'sub' && qtyInput) qtyInput.value = 1;

        // Delivery frequency select (only when a variant has more than one plan)
        if (freqWrap && freqSel) {
          if (alloc && v.allocations.length > 1) {
            freqSel.innerHTML = '';
            v.allocations.forEach(function (a) {
              var o = document.createElement('option');
              o.value = a.plan_id; o.textContent = a.plan_name;
              if (a.plan_id === state.plan) o.selected = true;
              freqSel.appendChild(o);
            });
            freqWrap.hidden = false;
          } else freqWrap.hidden = true;
        }

        // Price
        if (alloc) {
          priceEl.textContent = alloc.price;
          if (compareEl) { compareEl.textContent = alloc.compare && alloc.compare !== alloc.price ? alloc.compare : ''; }
          noteEl.textContent = [data.sub_note, v.tier_name ? v.tier_name + ' plan' : v.title, alloc.plan_name].filter(Boolean).join(' · ');
        } else {
          priceEl.textContent = v.price;
          if (compareEl) compareEl.textContent = v.compare || '';
          noteEl.textContent = v.unit || (data.variants.length > 1 ? v.title : '');
        }

        splitSync(v);
        idInput.value = v.id;
        planInput.value = alloc ? alloc.plan_id : '';
        planInput.disabled = !alloc;

        // Button
        var label;
        if (!v.available) label = data.labels.sold_out;
        else if (state.added) label = data.labels.added;
        else if (alloc) label = data.labels.sub.replace('[plan]', v.tier_name || v.title);
        else label = data.labels.once;
        addBtn.textContent = label;
        addBtn.disabled = !v.available;

        if (gallery && gallery.inn8Show && v.media_id) gallery.inn8Show(v.media_id);
        if (history.replaceState && el.dataset.updateUrl === 'true') {
          var u = new URL(location.href);
          u.searchParams.set('variant', v.id);
          if (alloc) u.searchParams.set('selling_plan', alloc.plan_id); else u.searchParams.delete('selling_plan');
          history.replaceState(null, '', u.toString());
        }
      };

      var touch = function () { state.added = false; if (msg) msg.textContent = ''; render(); };

      el.querySelectorAll('[data-mode-btn]').forEach(function (b) {
        b.addEventListener('click', function () { state.mode = b.dataset.modeBtn; touch(); });
      });
      el.querySelectorAll('[data-pack]').forEach(function (b) {
        b.addEventListener('click', function () { state.once = Number(b.dataset.pack); touch(); });
      });
      el.querySelectorAll('[data-plan-variant]').forEach(function (b) {
        b.addEventListener('click', function () { state.sub = Number(b.dataset.planVariant); touch(); });
      });
      if (freqSel) freqSel.addEventListener('change', function () { state.plan = Number(freqSel.value); touch(); });
      el.querySelectorAll('[data-qty-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = (parseInt(qtyInput.value, 10) || 1) + Number(b.dataset.qtyStep);
          qtyInput.value = Math.max(1, Math.min(99, n));
          state.added = false; render();
        });
      });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (state.added) { location.href = CART_URL; return; }
        var v = current();
        var alloc = currentAlloc(v);
        var item = { id: v.id, quantity: alloc ? 1 : Math.max(1, parseInt(qtyInput.value, 10) || 1) };
        if (alloc) item.selling_plan = alloc.plan_id;
        if (splitEl) {
          item.properties = {};
          item.properties[data.split.a] = String(split.a);
          item.properties[data.split.b] = String(split.b);
        }
        addBtn.disabled = true;
        addToCart([item])
          .then(function () { state.added = true; })
          .catch(function (err) { if (msg) msg.textContent = err.message; })
          .then(function () { addBtn.disabled = false; render(); });
      });

      render();
    });
  }


  /* ------------------------------------------------- diagram pin tooltips */
  function closePins(except) {
    document.querySelectorAll('[data-inn8-pin][aria-expanded="true"]').forEach(function (b) {
      if (b === except) return;
      b.setAttribute('aria-expanded', 'false');
      b.parentElement.classList.remove('is-open');
    });
  }
  function initPins(scope) {
    (scope || document).querySelectorAll('[data-inn8-pin]').forEach(function (btn) {
      if (btn.dataset.ready) return;
      btn.dataset.ready = '1';
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = btn.getAttribute('aria-expanded') !== 'true';
        closePins(btn);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.parentElement.classList.toggle('is-open', open);
      });
    });
  }
  document.addEventListener('click', function () { closePins(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePins(); });

  /* -------------------------------------------------------------- dialogs */
  function initDialogs(scope) {
    (scope || document).querySelectorAll('[data-inn8-open]').forEach(function (btn) {
      if (btn.dataset.ready) return;
      btn.dataset.ready = '1';
      var dlg = document.getElementById(btn.dataset.inn8Open);
      if (!dlg) return;
      if (dlg.parentElement !== document.body) document.body.appendChild(dlg); // escape transformed/overflow parents
      btn.addEventListener('click', function () {
        if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
        document.documentElement.classList.add('inn8-lock');
      });
      var shut = function () {
        if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open');
      };
      dlg.addEventListener('close', function () { document.documentElement.classList.remove('inn8-lock'); btn.focus(); });
      dlg.querySelectorAll('[data-inn8-close]').forEach(function (c) { c.addEventListener('click', shut); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) shut(); });
    });
  }

  /* ------------------------------------------------------------------ cart */
  function initCart(scope) {
    (scope || document).querySelectorAll('form[data-inn8-cart]').forEach(function (form) {
      if (form.dataset.ready) return;
      form.dataset.ready = '1';
      var timer = null;
      var queue = function () {
        clearTimeout(timer);
        timer = setTimeout(function () { form.classList.add('is-updating'); form.submit(); }, 450);
      };
      form.querySelectorAll('[data-cart-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          var input = b.parentElement.querySelector('[data-cart-qty]');
          input.value = Math.max(0, (parseInt(input.value, 10) || 0) + Number(b.dataset.cartStep));
          queue();
        });
      });
      form.querySelectorAll('[data-cart-qty]').forEach(function (i) { i.addEventListener('change', queue); });
    });
  }

  /* ------------------------------------------------- subscription builder */
  function initBuilder(scope) {
    (scope || document).querySelectorAll('[data-inn8-builder]').forEach(function (box) {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      var section = box.closest('section') || document;
      var picks = Array.prototype.slice.call(section.querySelectorAll('[data-tier-pick]'));
      var hasSplit = box.dataset.split === 'true';
      var addBtn = box.querySelector('[data-b-add]');
      var msg = box.querySelector('[data-b-msg]');
      var st = { pick: null, a: 0, b: 0 };
      var render = function () {
        if (!st.pick) return;
        var d = st.pick.dataset;
        box.querySelector('[data-b-title]').textContent = d.name + ' · ' + d.sub;
        box.querySelector('[data-b-price]').textContent = d.price ? d.price + ' ' + (box.dataset.suffix || '') : '';
        picks.forEach(function (p) {
          p.setAttribute('aria-pressed', p === st.pick ? 'true' : 'false');
          if (!p.dataset.label) p.dataset.label = p.textContent;
          p.textContent = p === st.pick ? (box.dataset.selected || 'selected ✓') : p.dataset.label;
        });
        if (hasSplit) {
          box.querySelector('[data-b-a]').textContent = st.a;
          box.querySelector('[data-b-b]').textContent = st.b;
          box.querySelectorAll('[data-b-step]').forEach(function (b) {
            var mine = st[b.dataset.bStep], other = b.dataset.bStep === 'a' ? st.b : st.a;
            b.disabled = Number(b.dataset.dir) < 0 ? mine <= 0 : other <= 0;
          });
        }
        addBtn.textContent = addBtn.dataset.label;
        addBtn.disabled = false;
        msg.textContent = '';
      };
      var choose = function (p, scroll) {
        var bags = Number(p.dataset.bags) || 0;
        if (st.pick !== p) { st.a = Math.ceil(bags / 2); st.b = bags - st.a; }
        st.pick = p;
        box.hidden = false;
        picks.forEach(function (q) {
          var card = q.closest('.inn8-tier');
          if (card) card.classList.toggle('is-selected', q === p);
        });
        render();
        if (scroll) smoothTo(box);
      };
      picks.forEach(function (p) {
        p.addEventListener('click', function () { choose(p, window.innerWidth < 990); });
      });
      // Pre-select from ?plan=20 (bags) or the highlighted plan.
      var want = new URLSearchParams(location.search).get('plan');
      var first = picks.filter(function (p) { return want && (p.dataset.bags === want || p.dataset.name === want); })[0]
        || picks.filter(function (p) { return p.dataset.featured === 'true'; })[0] || picks[0];
      if (first) choose(first, false);
      box.querySelectorAll('[data-b-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          var key = b.dataset.bStep, other = key === 'a' ? 'b' : 'a';
          if (Number(b.dataset.dir) > 0 && st[other] > 0) { st[key]++; st[other]--; }
          if (Number(b.dataset.dir) < 0 && st[key] > 0) { st[key]--; st[other]++; }
          render();
        });
      });
      addBtn.addEventListener('click', function () {
        if (!st.pick) return;
        var item = { id: Number(st.pick.dataset.variant), quantity: 1, selling_plan: Number(st.pick.dataset.plan) };
        if (hasSplit) {
          item.properties = {};
          item.properties[addBtn.dataset.propA] = String(st.a);
          item.properties[addBtn.dataset.propB] = String(st.b);
        }
        addBtn.disabled = true;
        addBtn.textContent = '…';
        addToCart([item])
          .then(function () { window.location.href = CART_URL; })
          .catch(function (err) { msg.textContent = err.message; addBtn.disabled = false; addBtn.textContent = addBtn.dataset.label; });
      });
    });
  }

  /* ------------------------------------------------------------------ boot */
  function init(scope) {
    initHeader(scope);
    initTabs(scope);
    initQuickAdd(scope);
    initGallery(scope);
    initProduct(scope);
    initCart(scope);
    initPins(scope);
    initDialogs(scope);
    initBuilder(scope);
    syncTabsHeight();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  window.addEventListener('resize', syncTabsHeight);
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
